export default __webpack_public_path__ + "static/media/summer-camp-2025.acddad5b.jpeg";